import { create } from 'zustand';

interface WalletState {
  isConnected: boolean;
  address: string;
  balance: string;
  connect: () => void;
  disconnect: () => void;
}

export const useWalletStore = create<WalletState>((set) => ({
  isConnected: false,
  address: '0x1b75eb...f94e',
  balance: '3,721.62 USDC',
  connect: () => set({ isConnected: true }),
  disconnect: () => set({ isConnected: false }),
}));
